<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="8"
            categoryName="Protector"
            categorySectionIcon="fa-wrench"
            :useSearch1="true"
            search1Title="Series"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'protector',
    components: { BaseInventory }
}
</script>
